export const getOidcStorageKey = () => {
  const authSettings = JSON.parse(localStorage.getItem('authSettings'));
  if (authSettings) {
    return `oidc.user:${authSettings.auth_server}:${authSettings.client_id}`;
  }
  return null;
};

export const getOidcInfo = () => {
  const key = getOidcStorageKey();
  if (key) {
    const oidc = JSON.parse(localStorage.getItem(key));
    return oidc;
  }
  return null;
};

export const getToken = () => {
  // Primeiro tenta obter o token do localStorage (Google ou token criptografado)
  const userData = localStorage.getItem('user');
  if (userData) {
    try {
      const user = JSON.parse(userData);
      // Prioriza accessToken (usado para Google) ou token (usado para token criptografado)
      if (user.accessToken) {
        return user.accessToken;
      }
      if (user.token) {
        return user.token;
      }
    } catch (error) {
      console.error('Erro ao processar dados do usuário:', error);
    }
  }
  
  // Fallback para o sistema OIDC antigo (se ainda existir)
  const oidc = getOidcInfo();
  if (oidc) {
    return oidc.id_token;
  }
  
  return null;
};

const getDay = (date) => {
  if (!date) return '';
  return `${new Date(date)?.getDate()}`;
};

const getValue = (price) => {
  if (Number.isNaN(price)) return 0;
  return Number(price).toFixed(2);
};

const getNameAndValueArr = history => history.map(day => ({
  name: getDay(day?.date),
  value: getValue(day.priceUsd),
}));

export const getWeekChartData = (cryptoHistory) => {
  if (!cryptoHistory) return null;

  const weekChartDataArr = cryptoHistory?.map(item => ({
    currency: item?.currency,
    history: getNameAndValueArr(item?.history.slice(7, item?.history.length)),
  }));

  return Object.fromEntries(weekChartDataArr.map(item => [item.currency, item.history]));
};

export const getShortCryptoAddress = value => `${value.slice(0, 5)}...${value.slice(-3)}`;
